'use client';

import styles from '@/app/(pages)/home/components/TrackAndCalculate/TrackAndCalculate.module.css';
import React from 'react';
import { InputAndBtn } from '@/components/ui/Input/InputAndBtn';

import { InfoLink } from '@/components/ui/InfoLink/InfoLink';

interface Props {
    urlInfo?: boolean;
}

export const TrackingForm = ({ urlInfo = false }: Props) => {
    return (
        <div className={styles.inputGroup}>
            <InputAndBtn />
            {!urlInfo && <InfoLink />}
        </div>
    );
};
